export const truncateString = (str, truncateFrom = 8, truncateUntil = 2) => {
    if (!str) {
        return "";
    }
    if (str.length <= truncateFrom)
        return str;
    const truncated = `${str.substring(0, truncateFrom)}…${str.substring(str.length - truncateUntil)}`;
    return truncated.length >= str.length ? str : truncated;
};
//# sourceMappingURL=string-format.js.map